import React from 'react'

interface AvatarProps {
  src?: string
  alt?: string
  name: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const sizeClasses = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-28 w-28 text-4xl'
}

const bgColors = [
  'bg-blue-500',
  'bg-green-500',
  'bg-purple-500',
  'bg-orange-500',
  'bg-pink-500',
  'bg-teal-500',
  'bg-indigo-500',
  'bg-rose-500',
]

const getColorFromName = (name: string): string => {
  const charSum = name.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0)
  return bgColors[charSum % bgColors.length]
}

export const Avatar: React.FC<AvatarProps> = ({ src, alt, name, size = 'md', className = '' }) => {
  const initials = name
    .split(' ')
    .filter(n => n.length > 0)
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .substring(0, 2) || 'U'

  const bgColor = getColorFromName(name)

  return (
    <div className={`${sizeClasses[size]} ${className} rounded-full overflow-hidden flex items-center justify-center ${src ? '' : bgColor}`}>
      {src ? (
        <img src={src} alt={alt || name} className="w-full h-full object-cover" />
      ) : (
        <span className="text-gray-900 dark:text-white font-bold">{initials}</span>
      )}
    </div>
  )
}
